module.exports = __webpack_public_path__ + "img/505585.737ed36b.svg";